import React, { useEffect, useState } from 'react';
import { db, auth } from '../firebase'; 
import { collection, getDocs } from 'firebase/firestore';
import DealCard from './DealCard';
import { Deal } from '../utils/constants';

export default function SavedDeals() {
  const [deals, setDeals] = useState<Deal[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSavedDeals = async () => {
      const currentUser = auth.currentUser;
      
      // If no one is logged in, stop looking and show the empty state
      if (!currentUser) {
        setLoading(false);
        return;
      }

      try {
        // Look in the exact Firebase folder where we confirmed the data is saving
        const savedRef = collection(db, 'users', currentUser.uid, 'savedDeals');
        const snapshot = await getDocs(savedRef);
        
        const fetchedDeals = snapshot.docs.map(doc => {
          const data = doc.data();
          // Putting the ID at the very end to prevent any overwriting!
          return { ...data, id: doc.id } as Deal;
        });

        setDeals(fetchedDeals);
      } catch (error) {
        console.error("Error fetching saved deals:", error);
      } finally {
        setLoading(false);
      }
    };

    // Firebase Auth needs a split second to initialize, so we listen for it
    const unsubscribe = auth.onAuthStateChanged((user) => {
        if (user) {
            fetchSavedDeals();
        } else {
            setLoading(false);
        }
    });

    return () => unsubscribe();
  }, []);

  if (loading) return <div className="p-10 text-center text-slate-500 font-bold">Loading your garage...</div>;

  return (
    <div className="container mx-auto p-4 w-full">
      <h1 className="text-2xl md:text-3xl font-black mb-6 text-slate-900">My Saved Upgrades ❤️</h1>
      
      {deals.length === 0 ? (
        <div className="text-center py-20 bg-white rounded-2xl border border-dashed border-slate-300 shadow-sm">
          <p className="text-xl text-slate-600 font-bold mb-2">Your garage is empty.</p>
          <p className="text-slate-400">Click the ❤️ on an upgrade to save it here for later.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
          {deals.map(deal => (
            <DealCard 
              key={deal.id} 
              deal={deal} 
              isAdmin={false} 
              isSelected={false}
            />
          ))}
        </div>
      )}
    </div>
  );
}